import { render, staticRenderFns } from "./RelatedGridItems.vue?vue&type=template&id=477e7a1f&"
import script from "./RelatedGridItems.vue?vue&type=script&lang=js&"
export * from "./RelatedGridItems.vue?vue&type=script&lang=js&"
import style0 from "./RelatedGridItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports